import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateQuoteSubtotal as UpdateQuoteSubtotalMutation,
    UpdateQuoteSubtotalVariables as UpdateQuoteSubtotalVariables,
    QuoteSubtotalItemsUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_QUOTE_SUBTOTAL from '../mutations/update-quote-subtotal.graphql';

export const useUpdateQuoteSubtotal = (): {
    updateQuoteSubtotal: (arg1: QuoteSubtotalItemsUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateQuoteSubtotal, {loading, error}] = useMutation<
        UpdateQuoteSubtotalMutation,
        UpdateQuoteSubtotalVariables
    >(UPDATE_QUOTE_SUBTOTAL);

    return {
        updateQuoteSubtotal: (input: QuoteSubtotalItemsUpdateInput) =>
            updateQuoteSubtotal({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
